<template>
    <divided-section 
        id="sek-description-section">
        <template v-slot:left-section>
            <container-title
                title-color="#141517"
                :title="'Simples\nDinâmico'"
                :sub-title="'Resolutivo'" />

            <div class="description-data">
                <div 
                    v-for="(content, index) in dataContent"
                    :key="index"
                    class="description-data-content">
                    {{ content }}
                </div>
            </div>
        </template>
        <template v-slot:right-section> </template>
    </divided-section>
</template>

<script>
import DividedSection from "@/components/structure/DividedSection"
import ContainerTitle from "@/components/utils/ContainerTitle"


export default {
    components: {
        "divided-section": DividedSection,
        "container-title": ContainerTitle,
    },
    data() {
        return {
            dataContent: [
                "Suporte e acompanhamento completo durante\ntodo o processo na venda",
                "Gestão e controle na implantação da apólice /\nacompanhamento total de movimentações cadastrais",
                "Gestão e controle de inadimplência, retenção de\ncarteira e regulação de sinistro"
            ]
        }
    },
    mounted() {
        document
            .querySelector("#sek-description-section")
            .setAttribute("style", `height: ${document.querySelector("#sek-description-section .left-section").offsetHeight}px;`)
    }
}
</script>

<style lang="scss">
#sek-description-section {

    .left-section {
        background-color: $c-white;
        padding-top: 75px;

        .description-data {
            counter-reset: countNumber;
            margin-top: 50px;

            .description-data-content {
                counter-increment: countNumber;
                padding-left: 90px;
                margin-bottom: 35px;
                font-size: 18px;
                font-weight: 300;
                color: #707070;
                position: relative;
                min-height: 64px;
                white-space: pre-line;
            
                &:first-child {
                    &::before {
                        background: black;
                    }
                }

                &::after {
                    position: absolute;
                    font-size: 35px;
                    left: 22px;
                    top: 4px;
                    font-weight: bold;
                    color: #007ac0;
                    content: counter(countNumber);
                }

                &::before {
                    content: "";
                    position: absolute;
                    width: 64px;
                    height: 64px;
                    left: 0;
                    top: -3px;
                    border-radius: 50%;
                    border: 5px solid #007ac0;
                }
            }
        }
    }
}
</style>